// Stable, sortable-enough ids for local-first records. crypto.randomUUID is available in
// every WebView/browser this app targets; the fallback only exists for exotic test hosts.
export function newId(prefix: string): string {
  const rand =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  return `${prefix}_${rand}`;
}
